import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { LINKS } from "@/i18n/translations";
import { Reveal } from "./Reveal";

const Shot = ({ src, alt }) => (
  <div className="w-[240px] sm:w-[270px] rounded-[36px] border border-white/12 bg-[#0d0d10] p-2 shadow-2xl">
    <img
      src={src}
      alt={alt}
      width="390"
      height="800"
      loading="lazy"
      className="rounded-[28px] w-full h-auto"
    />
  </div>
);

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="como-funciona" className="mx-auto max-w-7xl px-4 sm:px-8 py-20 sm:py-32">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#f5a623]">
          {t.how.kicker}
        </p>
        <h2 className="mt-3 font-black tracking-tighter text-3xl sm:text-4xl max-w-xl">
          {t.how.title}
        </h2>
      </Reveal>

      <div className="mt-14 space-y-20 sm:space-y-28">
        {t.how.steps.map((step, i) => (
          <Reveal key={step.num}>
            <div
              className={`grid md:grid-cols-2 gap-10 items-center ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="md:[direction:ltr]">
                <span className="lp-chapter-num block select-none" aria-hidden="true">
                  {step.num}
                </span>
                <h3 className="mt-4 text-2xl sm:text-3xl font-extrabold tracking-tight">
                  {step.title}
                </h3>
                <p className="mt-4 text-[#a1a1aa] leading-relaxed max-w-md">{step.text}</p>
              </div>
              <div className="flex justify-center md:[direction:ltr]">
                <Shot src={step.img} alt={step.alt} />
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-24">
        <div className="relative overflow-hidden rounded-3xl border border-[#f5a623]/25 bg-gradient-to-br from-[#f5a623]/10 to-transparent p-8 sm:p-12">
          <div className="max-w-2xl">
            <h3 className="text-2xl sm:text-3xl font-extrabold tracking-tight">
              {t.how.demoTitle}
            </h3>
            <p className="mt-4 text-[#a1a1aa] leading-relaxed">
              {t.how.demoText.split("demo")[0]}
              <code className="mx-1 rounded-md bg-[#f5a623]/20 border border-[#f5a623]/30 px-2 py-0.5 font-bold text-[#f5a623]">
                demo
              </code>
              {t.how.demoText.split("demo").slice(1).join("demo")}
            </p>
            <a
              href={LINKS.demo}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="demo-section-cta"
              className="group mt-6 inline-flex items-center gap-2 rounded-full border border-[#f5a623] text-[#f5a623] font-bold px-6 py-3 hover:bg-[#f5a623] hover:text-[#09090b] transition-colors"
            >
              {t.how.demoCta}
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
